import {
  convertUnitPrice,
  roundQuotePrice,
  type QuoteCurrencyContext,
} from "@forgepoint/shared";

/**
 * Converts a base-currency unit price into the quote currency at the quote's
 * snapshot rate and applies the quote's price rounding, as the quote line does.
 */
export const quoteCurrencyUnitPrice = (
  baseUnitPrice: string,
  context: QuoteCurrencyContext,
): string => {
  const converted = convertUnitPrice(baseUnitPrice, context);
  const rounding = context.quotePriceRounding;
  return rounding ? roundQuotePrice(converted, rounding) : converted;
};
